<template>
    <div class="svg-map">
        <div class="svg-map-bg" v-if="bg" v-html="svg(bg)"></div>
        <div class="svg-map-src" v-html="svg(src)" ref="svg"></div>
    </div>
</template>

<script>
    import svg from '../svg'
    import {each} from 'lodash'

    export default {
        name: 'SvgMap',
        props: {
            src: {required: true},
            bg: {},
            map: {},
        },
        mounted () {
            each(this.map, (color, id) => {
                let path = this.$refs.svg.querySelector(`#${id}`)
                if (path) {
                    path.style.fill = color
                }
            })
        },
        methods: {
            svg,
        },
    }
</script>

<style lang="less">
    @import "../../less/_boot";
    .svg-map {
        width: 100%;
        .clearfix();
        svg {
            width: 100%;
            height: auto;
        }
        &-bg {
            float: left;
            width: 100%;
            margin-right: -100%;
        }
        &-src {
            float: left;
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// SvgMap.vue?179f9bcc